/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import {
	RichText 
} from '@wordpress/block-editor'

/**
 * Internal dependencies
 */
import { name } from './index'
import { 
	ButtonEditHelper, ImageUploadPlaceholder 
} from '~cartzillagb/components'

/**
 * External dependencies
 */
import classnames from 'classnames'

const save = props => {
		const { 
		setAttributes,
		attributes, 
		className
	} = props 

	const mainClasses = classnames( [
		className,
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	return (
		<div className={ mainClasses }>
			<ButtonEditHelper.Content
				attrNameTemplate={ `button1%s` }
				blockAttributes={ props.attributes }
			/>
		</div>
	)
}

export default compose(
)( save )